import type { ListingCopy } from '@/api/listings'

const FIELDS: ReadonlyArray<{ key: keyof ListingCopy; label: string }> = [
  { key: 'title', label: 'Title' },
  { key: 'shortDescription', label: 'Short description' },
  { key: 'longDescription', label: 'Long description' },
  { key: 'seoTitle', label: 'SEO title' },
  { key: 'seoDescription', label: 'SEO description' },
  { key: 'emailCopy', label: 'Email copy' },
  { key: 'pushCopy', label: 'Push copy' },
  { key: 'socialCopy', label: 'Social copy' },
  { key: 'adCopy', label: 'Ad copy' },
  { key: 'offlineFlyerHeadline', label: 'Offline flyer headline' },
]

/** The generator's draft, read-only: reviewed and approved as a whole, then regenerated if it needs changing. */
export function ListingCopyPreview({ copy }: { copy: ListingCopy }) {
  return (
    <dl className="lst-copy">
      {FIELDS.map(({ key, label }) => (
        <div key={key} className="lst-copy__field">
          <dt>{label}</dt>
          <dd>{copy[key] as string}</dd>
        </div>
      ))}
      {copy.keyPoints.length > 0 ? (
        <div className="lst-copy__field">
          <dt>Key points</dt>
          <dd>
            <ul>
              {copy.keyPoints.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </dd>
        </div>
      ) : null}
    </dl>
  )
}
